module.exports = __webpack_public_path__ + "img/20210901_075540.ce83cac8.jpg";